// extracted by mini-css-extract-plugin
export default {"layout_Wrapper":"navLayout_layout_Wrapper__eD7K2"};